// Generated by scripts/fetch-laws.ts from lawsofux.com and timsommer.be. Do not edit directly.
import type { Law } from "../types";

export const knuthsOptimizationPrinciple: Law = {
  slug: "knuths-optimization-principle",
  title: "Knuth's optimization principle",
  definition: "Premature optimization is the root of all evil.",
  category: "theory",
  color: "#c8bc00",
  labels: ["cs","software-engineering"],
  copy: ["First you write code, then you identify bottlenecks, then you fix!"],
  sources: ["https://www.timsommer.be/famous-laws-of-software-development/"],
  related: [],
};
